import { render, staticRenderFns } from "./NibedanBibaran.vue?vue&type=template&id=5f231456&"
import script from "./NibedanBibaran.vue?vue&type=script&lang=js&"
export * from "./NibedanBibaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports